import React, { useEffect, useCallback, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createPendingSelector } from 'modules/api/selectors';
import ActiveUsersView from '../views/ActiveUsersView';
import { getActiveUsersGraphDataRequest } from '../actions';
import { getActiveUsersGraphDatasets, getActiveUserGraphData } from '../selectors';
import {
  DASHBOARD_ACTIVE_USERS_HEADER_FORM,
  INITIAL_ACTIVE_USERS_FILTERS_VALUES,
} from '../constants';
import { mapActiveUsersParamsToRequestPayload } from '../utils/mappers';
import TPLoader from 'components/TP-UI/TPLoader';
import NoDataAvailable from 'modules/common/NoDataAvailable';
import { hasOnlyEmptyValues } from 'utils/hasOnlyEmptyValues';
import { useTheme } from '@material-ui/core';
import getDataset from '../views/ActiveUsersView/getDataset';

const ActiveUsersContainer = () => {
  const dispatch = useDispatch();
  const pending = useSelector(createPendingSelector(getActiveUsersGraphDataRequest));
  const graphDatasets = useSelector(getActiveUsersGraphDatasets);
  const activeUsersData = useSelector(getActiveUserGraphData);
  const [filterApplied, setFilterApplied] = useState(
    !hasOnlyEmptyValues(INITIAL_ACTIVE_USERS_FILTERS_VALUES),
  );
  const { palette } = useTheme();
  const dataset = useMemo(() => getDataset(graphDatasets, palette), [graphDatasets, palette]);

  useEffect(() => {
    dispatch(
      getActiveUsersGraphDataRequest(
        mapActiveUsersParamsToRequestPayload(INITIAL_ACTIVE_USERS_FILTERS_VALUES),
      ),
    );
  }, [dispatch]);

  const handleChange = useCallback(
    (data) => {
      setFilterApplied(!hasOnlyEmptyValues(data));
      dispatch(getActiveUsersGraphDataRequest(mapActiveUsersParamsToRequestPayload(data)));
    },
    [dispatch],
  );

  return !activeUsersData ? (
    <TPLoader />
  ) : activeUsersData.length === 0 && !filterApplied && !pending ? (
    <NoDataAvailable />
  ) : (
    <ActiveUsersView
      loading={pending}
      items={activeUsersData}
      dataset={dataset}
      form={DASHBOARD_ACTIVE_USERS_HEADER_FORM}
      onChange={handleChange}
    />
  );
};

export default ActiveUsersContainer;
